import iconCheckMark from '@/assets/images/SVG/grid/r3-checkmark.svg'

export default {
    landingPageStatusConfig: {
        Published: {
            style:{
                background: '#E2F4E3',
                color: '#2ADA2B'
            },

            label: 'Published'
        },


        Unpublished: {
            style:{
                background: '#FDF2E6',
                color: '#ED8A20'
            },

            label: 'Unpublished'
        }
    },

    updateStatusConfig: {
        DRAFT: {
            style: {
                background: '#FDF2E6',
                color: '#ED8A20',
            },
            label: 'Draft',
        },
        SCHEDULED: {
            style: {
                background: '#E5F6FF',
                color: '#18AEFF',
            },
            label: 'Scheduled',
        },
        SENT: {
            style: {
                background: '#E2F4E3',
                color: '#2ADA2B',
            },
            label: 'Sent',
        },
    },

    partnerAccessStatusConfig: {
        pending: {
            style: {
                background: '#FDF2E6',
                color: '#EB7E0A',
            },
            label: 'Pending',
        },
        deny: {
            style: {
                background: '#F8E9F0',
                color: '#F30070',
            },
            label: 'Denied',
        },
        accept: {
            style: {
                background: '#E2F4E3',
                color: '#2ADA2B',
            },
            label: 'Active',
        },
    },

    socialMediaStatusConfig: {
        draft: {
            style: {
                background: '#FDF2E6',
                color: '#ED8A20',
            },
            label: 'Draft',
        },
        scheduled: {
            style: {
                background: '#E5F6FF',
                color: '#18AEFF',
            },
            label: 'Scheduled',
        },
        posted: {
            style: {
                background: '#E2F4E3',
                color: '#2ADA2B',
            },
            label: 'Posted',
        },
        error: {
            style: {
                'background': '#F8E9F0',
                'color': '#F30070',
            },
            label: 'Error',
        },
        posting: {
            style: {
                background: '#E2F4E3',
                color: '#2ADA2B',
            },
            label: 'Posting...',
        },
    },

    invoiceStatusConfig: {
        unpaid: {
            style: {
                background: '#FDF2E6',
                color: '#EB7E0A',
            },
            label: 'Unpaid',
        },
        overdue: {
            style: {
                background: '#F8E9F0',
                color: '#F30070',
            },
            label: 'Overdue',
        },
        paid: {
            style: {
                background: '#E2F4E3',
                color: '#2ADA2B',
            },
            label: 'Paid',
            icon: iconCheckMark
        },
    },

    partnerSurveysConfig: {
        client: {
            not_started: {
                style: {
                    background: '#F8E9F0',
                    color: '#F30070',
                },
                label: 'Pending',
            },
            pending: {
                style: {
                    background: '#F8E9F0',
                    color: '#F30070',
                },
                label: 'Pending',
            },
            viewed: {
                style: {
                    background: '#F8E9F0',
                    color: '#F30070',
                },
                label: 'Pending',
            },
            draft: {
                style: {
                    background: '#FDF2E6',
                    color: '#EB7E0A',
                },
                label: 'Draft',
            },
            completed: {
                style: {
                    background: '#E2F4E3',
                    color: '#2ADA2B',
                },
                label: 'Completed',
            },
        },
        
        agency: {
            not_started: {
                style: {
                    background: '#E9E9EF',
                    color: '#877D88',
                },
                label: 'Not Started',
            },
            viewed: {
                style: {
                    background: '#7A5BFF26',
                    color: '#7A5BFF',
                },
                label: 'Viewed',
            },
            draft: {
                style: {
                    background: '#FDF2E6',
                    color: '#EB7E0A',
                },
                label: 'Draft',
            },
            completed: {
                style: {
                    background: '#E2F4E3',
                    color: '#2ADA2B',
                },
                label: 'Completed',
            },
        }
    },

    paymentReceivedStatusConfig:{
        paid: {
            style: {
                    background: '#E2F4E3',
                    color: '#2ADA2B',
            },  
            label: 'Funds Paid',
        },
        no_paid: {
            style: {
                    background: '#FDF2E6',
                    color: '#EB7E0A',
            },
            label: 'Pending Approval',
        },
        paying: {
            style: {
                background: '#E5F6FF',
                color: '#18AEFF',
            },
            label: 'Funds in Transit',
        },
    },
};
